"use strict";

/*!
 * Splide carousel init
 */

var splideInstances = new Map();

var CAROUSEL_SELECTORS = [
  '.trend-carousel',
  '.large-slider',
  '.three-up-slider',
  '.four-up-slider',
  '.collections-slider',
  '.dynamic_blog_carousel'
];

function initSplide(el, options) {
  if (splideInstances.has(el)) return;
  if (typeof Splide === 'undefined') return;
  var splide = new Splide(el, options);
  splide.mount();
  splideInstances.set(el, splide);
}

// Returns type/arrows based on whether slides overflow desktop perPage.
// slideCount > 1 is intentionally not used: e.g. 3 slides in a four-up would
// still loop on desktop, causing Splide to clone and show duplicates.
function loopOptions(el, perPage) {
  var loop = el.querySelectorAll('.splide__slide').length > perPage;
  return { type: loop ? 'loop' : 'slide', arrows: loop };
}

function initCarousels(container) {
  container.querySelectorAll('.trend-carousel').forEach(function(el) {
    var slideCount = el.querySelectorAll('.splide__slide').length;
    initSplide(el, {
      perPage: 1,
      perMove: 1,
      arrows: false,
      flickMaxPages: 1,
      pagination: slideCount > 1,
      speed: 400,
      type: 'slide'
    });
  });

  container.querySelectorAll('.large-slider').forEach(function(el) {
    var slideCount = el.querySelectorAll('.splide__slide').length;
    var multi = slideCount > 1;
    initSplide(el, {
      perPage: 1,
      perMove: 1,
      arrows: multi,
      pagination: false,
      speed: 300,
      type: multi ? 'loop' : 'slide',
      breakpoints: {
        800: { arrows: false, pagination: multi }
      }
    });
  });

  container.querySelectorAll('.four-up-slider').forEach(function(el) {
    var slideCount = el.querySelectorAll('.splide__slide').length;
    initSplide(el, Object.assign(loopOptions(el, 4), {
      perPage: 4,
      perMove: 4,
      pagination: false,
      speed: 300,
      flickMaxPages: 1,
      breakpoints: {
        800: { perPage: 2, perMove: 1, arrows: false, pagination: slideCount > 2 },
        500: { perPage: 1, perMove: 1, arrows: false, pagination: slideCount > 1 }
      }
    }));
  });

  container.querySelectorAll('.collections-slider').forEach(function(el) {
    if (window.innerWidth > 800) return;
    initSplide(el, {
      perPage: 1,
      perMove: 1,
      arrows: false,
      pagination: true,
      speed: 300,
      type: 'slide',
      breakpoints: {
        800: { perPage: 1, perMove: 1 }
      }
    });
  });

  container.querySelectorAll('.three-up-slider').forEach(function(el) {
    var slideCount = el.querySelectorAll('.splide__slide').length;
    initSplide(el, Object.assign(loopOptions(el, 3), {
      perPage: 3,
      perMove: 3,
      pagination: false,
      speed: 300,
      flickMaxPages: 1,
      breakpoints: {
        1440: { perPage: 2, perMove: 1, arrows: false, pagination: slideCount > 2 },
        500: { perPage: 1, perMove: 1, arrows: false, pagination: slideCount > 1 }
      }
    }));
  });

  container.querySelectorAll('.dynamic_blog_carousel').forEach(function(el) {
    var multi = el.querySelectorAll('.splide__slide').length > 1;
    initSplide(el, {
      perPage: 1,
      perMove: 1,
      pagination: multi,
      arrows: false,
      focus: 'center',
      flickMaxPages: 1,
      type: multi ? 'loop' : 'slide'
    });
  });

}

function destroyCarousels(container) {
  CAROUSEL_SELECTORS.forEach(function(selector) {
    container.querySelectorAll(selector).forEach(function(el) {
      var instance = splideInstances.get(el);
      if (instance) {
        instance.destroy();
        splideInstances.delete(el);
      }
    });
  });
}

function bindChatToggle(container) {
  var root = container || document;
  var pdpMessageBtn = root.querySelector ? root.querySelector('.share__social-link.chat-toggle') : null;
  var chatWidget = document.getElementById('ShopifyChat');
  if (pdpMessageBtn && chatWidget && !pdpMessageBtn.dataset.chatBound) {
    pdpMessageBtn.addEventListener('click', function() { chatWidget.click(); });
    pdpMessageBtn.dataset.chatBound = 'true';
  }
}


document.addEventListener('DOMContentLoaded', function() {
  initCarousels(document);
  bindChatToggle(document);
});

document.addEventListener('shopify:section:load', function(event) {
  initCarousels(event.target);
  bindChatToggle(event.target);
});

document.addEventListener('shopify:section:unload', function(event) {
  destroyCarousels(event.target);
});

/* =============================================================================
   Premium PDP — size display update + Swym variant ID sync
   Change handler uses event delegation so it works for both the PDP and
   dynamically loaded quickshop instances.
   ============================================================================= */
(function () {
  /* Update the "Size: XS" / "Color: Jardin" text when a radio option changes.
     Scoped to the nearest .premium-pdp so it works when multiple instances exist. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.classList.contains('option-value-input')) return;
    var pdp = input.closest('.premium-pdp');
    if (!pdp) return;

    var optionAttr = input.getAttribute('data-product-option');
    var display = pdp.querySelector('[data-premium-option-display="' + CSS.escape(optionAttr) + '"]');
    if (display) display.textContent = input.value;

    var sizeOptions = input.closest('.premium-size-options');
    if (sizeOptions) {
      sizeOptions.querySelectorAll('.premium-size-pill').forEach(function (pill) {
        pill.classList.remove('is-selected');
      });
      var pill = input.closest('.premium-size-pill');
      if (pill) pill.classList.add('is-selected');
    }
  });

  /* Everything below only runs on PDP pages where .premium-pdp exists at load */
  if (!document.querySelector('.premium-pdp')) return;

  /* Parse variant data from Atlantic's embedded product JSON for price updates */
  var productVariants = [];
  var sectionDataEl = document.querySelector('[data-section-data]');
  if (sectionDataEl) {
    try { productVariants = JSON.parse(sectionDataEl.textContent).product.variants || []; } catch (e) {}
  }

  function updatePremiumPrice(variantId) {
    if (!window.Shopify || !Shopify.formatMoney) return;
    var variant = productVariants.filter(function (v) { return String(v.id) === String(variantId); })[0];
    if (!variant) return;
    var priceEl = document.querySelector('.premium-price');
    if (!priceEl) return;
    var fmt = function (cents) { return Shopify.formatMoney(cents, Shopify.money_format); };
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceEl.innerHTML = '<span class="premium-price__sale money">' + fmt(variant.price) + '</span><s class="premium-price__compare money">' + fmt(variant.compare_at_price) + '</s>';
    } else {
      priceEl.innerHTML = '<span class="premium-price__regular money">' + fmt(variant.price) + '</span>';
    }
  }

  /* Update price + sync Swym variant ID when atlantic.js switches variants */
  var atcBtn = document.querySelector('.premium-atc-btn');
  var wishlistDiv = document.querySelector('.premium-wishlist-btn[data-with-epi]');

  if (atcBtn) {
    var observer = new MutationObserver(function () {
      var variantId = atcBtn.getAttribute('data-product-variant-id');
      if (!variantId) return;
      updatePremiumPrice(variantId);
      if (wishlistDiv) wishlistDiv.setAttribute('data-variant-id', variantId);
    });
    observer.observe(atcBtn, { attributes: true, attributeFilter: ['data-product-variant-id'] });
    var initialVariantId = atcBtn.getAttribute('data-product-variant-id');
    if (initialVariantId) updatePremiumPrice(initialVariantId);
  }

  /* Set initial is-selected class on page load */
  document.querySelectorAll('.premium-size-pill input:checked').forEach(function (input) {
    input.closest('.premium-size-pill').classList.add('is-selected');
  });

  /* Premium PDP: proxy "View store information" click to Atlantic's surface pick-up drawer */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('.premium-store-link');
    if (!link) return;
    e.preventDefault();
    var modalBtn = document.querySelector('.surface-pick-up-embed__modal-btn');
    if (modalBtn) modalBtn.click();
  });

  /* Move KiwiSizing size guide inline with the Size: label row */
  var premiumSection = document.querySelector('.premium-pdp');
  var ksObserver = new MutationObserver(function (mutations, obs) {
    var ksContainer = document.querySelector('.ks-chart-container');
    if (!ksContainer) return;
    clearTimeout(ksTimeout);
    var sizeGroup = premiumSection.querySelector('.premium-option-group--size');
    if (!sizeGroup) return;
    var sizePills = sizeGroup.querySelector('.premium-size-options');
    sizeGroup.insertBefore(ksContainer, sizePills);
    var ksTextSpan = ksContainer.querySelector('._ks_text');
    if (ksTextSpan) {
      ksTextSpan.textContent = ksTextSpan.textContent.toLowerCase().replace(/\b\w/g, function(l) { return l.toUpperCase(); });
    }
    obs.disconnect();
  });
  var ksTimeout = setTimeout(function () { ksObserver.disconnect(); }, 8000);
  ksObserver.observe(premiumSection, { childList: true, subtree: true });
})();

// Mobile snap gallery — dot sync + zoom modal
(function () {
  var gallery = document.querySelector('[data-mobile-gallery]');
  if (!gallery) return;
  if (gallery.dataset.mobileGalleryInitialized === 'true') return;
  gallery.dataset.mobileGalleryInitialized = 'true';

  var track = gallery.querySelector('[data-mobile-gallery-track]');
  var dots = Array.prototype.slice.call(gallery.querySelectorAll('.mobile-snap-gallery__dot'));
  if (!track) return;

  // Dot sync
  track.addEventListener('scroll', function () {
    var index = Math.round(track.scrollLeft / track.clientWidth);
    dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === index); });
  }, { passive: true });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      track.scrollTo({ left: parseInt(dot.getAttribute('data-index'), 10) * track.clientWidth, behavior: 'smooth' });
    });
  });

  // Collect image data
  var imageSlides = Array.prototype.slice.call(track.querySelectorAll('[data-modal-index]'));
  if (!imageSlides.length) return;

  var images = imageSlides.map(function (slide) {
    var el = slide.querySelector('img');
    return {
      full: slide.getAttribute('data-full-src'),
      preview: el ? (el.currentSrc || el.src) : slide.getAttribute('data-full-src'),
      alt: slide.getAttribute('data-alt') || ''
    };
  });

  var total = images.length;
  var modal = null;
  var stage = null;
  var currentIndex = 0;
  var currentImg = null;
  var scale = 1, tx = 0, ty = 0;
  var moved = false, startDist = 0, startScale = 1;
  var startX = 0, startY = 0, startTX = 0, startTY = 0;
  var swipeDX = 0;
  var MOVE_THRESHOLD = 8;
  var SWIPE_THRESHOLD = 50;

  // Open on tap
  track.addEventListener('click', function (e) {
    var slide = e.target.closest('[data-modal-index]');
    if (!slide) return;
    openModal(parseInt(slide.getAttribute('data-modal-index'), 10));
  });

  function buildModal() {
    modal = document.createElement('div');
    modal.className = 'zoom-modal';
    modal.innerHTML =
      '<button class="zoom-modal__close" aria-label="Close">×</button>' +
      '<div class="zoom-modal__count"></div>' +
      (total > 1 ? '<button class="zoom-modal__prev" aria-label="Previous">‹</button><button class="zoom-modal__next" aria-label="Next">›</button>' : '') +
      '<div class="zoom-modal__stage">' +
      images.map(function (_, i) {
        return '<div class="zoom-modal__item" data-modal-item="' + i + '"><img class="zoom-modal__img" alt=""></div>';
      }).join('') +
      '</div>';

    document.body.appendChild(modal);
    stage = modal.querySelector('.zoom-modal__stage');

    modal.querySelector('.zoom-modal__close').addEventListener('click', closeModal);
    if (total > 1) {
      modal.querySelector('.zoom-modal__prev').addEventListener('click', function () { navigate(-1); });
      modal.querySelector('.zoom-modal__next').addEventListener('click', function () { navigate(1); });
    }
    stage.addEventListener('touchstart', onTouchStart, { passive: false });
    stage.addEventListener('touchmove', onTouchMove, { passive: false });
    stage.addEventListener('touchend', onTouchEnd);
  }

  var scrollY = 0;

  function lockBody() {
    scrollY = window.scrollY || window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBody() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  function openModal(index) {
    if (!modal) buildModal();
    // Clear any item left active from a previous session
    var prev = modal.querySelector('.zoom-modal__item--active');
    if (prev) prev.classList.remove('zoom-modal__item--active');
    currentIndex = index;
    resetZoom();
    showItem(index);
    updateChrome();
    modal.classList.add('zoom-modal--open');
    lockBody();
  }

  function closeModal() {
    modal.classList.remove('zoom-modal--open');
    unlockBody();
    resetZoom();
  }

  function navigate(dir) {
    modal.querySelector('[data-modal-item="' + currentIndex + '"]').classList.remove('zoom-modal__item--active');
    currentIndex = (currentIndex + dir + total) % total;
    resetZoom();
    showItem(currentIndex);
    updateChrome();
  }

  function showItem(index) {
    var item = modal.querySelector('[data-modal-item="' + index + '"]');
    item.classList.add('zoom-modal__item--active');
    currentImg = item.querySelector('.zoom-modal__img');
    currentImg.alt = images[index].alt;
    if (!currentImg.getAttribute('data-loaded')) {
      currentImg.setAttribute('data-loaded', '1');
      currentImg.src = images[index].preview;
      var hi = new Image();
      hi.onload = (function (idx) {
        return function () {
          var el = modal.querySelector('[data-modal-item="' + idx + '"] .zoom-modal__img');
          if (el) el.src = images[idx].full;
        };
      }(index));
      hi.src = images[index].full;
    }
  }

  function updateChrome() {
    modal.querySelector('.zoom-modal__count').textContent = total > 1 ? (currentIndex + 1) + ' / ' + total : '';
  }

  function resetZoom() { scale = 1; tx = 0; ty = 0; applyTransform(); }

  function applyTransform() {
    if (currentImg) currentImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
  }

  function clampPan() {
    if (!currentImg || !stage) return;
    var maxTX = Math.max(0, (currentImg.offsetWidth * scale - stage.clientWidth) / 2);
    var maxTY = Math.max(0, (currentImg.offsetHeight * scale - stage.clientHeight) / 2);
    tx = Math.min(maxTX, Math.max(-maxTX, tx));
    ty = Math.min(maxTY, Math.max(-maxTY, ty));
  }

  function tapZoom(tapX, tapY) {
    if (scale > 1.05) {
      scale = 1; tx = 0; ty = 0;
    } else {
      var newScale = 2.5;
      var rect = currentImg.getBoundingClientRect();
      var imgCX = rect.left + rect.width / 2;
      var imgCY = rect.top + rect.height / 2;
      tx = (imgCX - tapX) * (newScale - 1);
      ty = (imgCY - tapY) * (newScale - 1);
      scale = newScale;
      clampPan();
    }
    applyTransform();
  }

  function ptDist(a, b) {
    var dx = a.clientX - b.clientX, dy = a.clientY - b.clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  function onTouchStart(e) {
    moved = false;
    swipeDX = 0;
    if (e.touches.length === 2) {
      startDist = ptDist(e.touches[0], e.touches[1]);
      startScale = scale;
      e.preventDefault();
    } else if (e.touches.length === 1) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      startTX = tx; startTY = ty;
    }
  }

  function onTouchMove(e) {
    e.preventDefault();
    if (e.touches.length === 2) {
      moved = true;
      scale = Math.min(4, Math.max(1, startScale * ptDist(e.touches[0], e.touches[1]) / startDist));
      clampPan();
      applyTransform();
      return;
    }
    if (e.touches.length !== 1) return;
    var dx = e.touches[0].clientX - startX;
    var dy = e.touches[0].clientY - startY;
    swipeDX = dx;
    if (Math.abs(dx) > MOVE_THRESHOLD || Math.abs(dy) > MOVE_THRESHOLD) moved = true;
    if (scale > 1) {
      tx = startTX + dx;
      ty = startTY + dy;
      clampPan();
      applyTransform();
    }
  }

  function onTouchEnd(e) {
    if (!moved) {
      tapZoom(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
      return;
    }
    if (scale <= 1.05 && Math.abs(swipeDX) > SWIPE_THRESHOLD) {
      navigate(swipeDX < 0 ? 1 : -1);
    } else if (scale < 1.05) {
      scale = 1; tx = 0; ty = 0;
      applyTransform();
    }
  }
})();

/* ==========================================================================
   New Navigation hooks (May 2026)
   - Track open mega-panel state on .main-header-wrap
   - Mobile accordion: single-open enforcement, aria-expanded toggling
   - Home-page transparent header: combine scroll + panel-open state
   ========================================================================== */
(function () {
  /* Single source of truth: .is-open class on .nav-item.has-mega-panel.
     JS owns: .is-open, .main-header--panel-open, <details open>, aria-hidden, aria-expanded.
     CSS does NOT use :hover or :has(details[open]) to open the panel.

     State/helpers live at module scope so the header can be re-initialized after
     shopify:section:load (theme editor) swaps the header DOM. Element listeners are
     re-bound against the fresh DOM each init; document-level listeners are bound once. */
  const HOVER_OPEN_MS = 50;
  const HOVER_CLOSE_MS = 200;
  let headerWrap = null;
  let navRoot = null;
  let openTimer = null;
  let closeTimer = null;
  let activeItem = null;
  let docListenersBound = false;
  /* atlantic.js opens the native <details> on mouseenter, which fires `toggle`.
     Panel visibility is keyed off .is-open (not [open]), so we ignore those
     hover-driven opens and let the mouseenter timer own hover. This flag marks a
     genuine keyboard activation (Enter/Space) so the toggle handler still opens
     the panel for keyboard users. */
  let keyboardActivation = false;

  function clearTimers() {
    if (openTimer) { clearTimeout(openTimer); openTimer = null; }
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
  }

  function setItemState(item, isOpen) {
    if (isOpen) item.classList.add('is-open');
    else item.classList.remove('is-open');

    const d = item.querySelector('details[data-megapanel-details]');
    if (d) {
      if (isOpen && !d.hasAttribute('open')) d.setAttribute('open', '');
      if (!isOpen && d.hasAttribute('open')) d.removeAttribute('open');
    }

    const summary = item.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    item.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    const panel = item.querySelector('.mega-panel');
    if (panel) panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
  }

  function closeAll(force) {
    /* If cursor is still in the header when a grace-delay timer fires (stale timer
       from a transition through dead space), bail — the next mouseleave will retry.
       Esc / click-outside pass force=true to close even while hovering. */
    if (!navRoot) return;
    if (!force && navRoot.matches(':hover')) return;
    navRoot.querySelectorAll('.nav-item.has-mega-panel.is-open').forEach((item) => {
      setItemState(item, false);
    });
    activeItem = null;
    if (headerWrap) headerWrap.classList.remove('main-header--panel-open');
  }

  function openItem(item) {
    if (item === activeItem) return;
    navRoot.querySelectorAll('.nav-item.has-mega-panel.is-open').forEach((i) => {
      if (i !== item) setItemState(i, false);
    });
    setItemState(item, true);
    activeItem = item;
    headerWrap.classList.add('main-header--panel-open');
  }

  /* relatedTarget check: when mouse leaves an element but is moving to another
     element inside the header, don't schedule a close — it's still in our area. */
  function isMovingWithinHeader(e) {
    return e.relatedTarget && headerWrap && headerWrap.contains(e.relatedTarget);
  }

  /* Bind hover/keyboard listeners to the current nav DOM. Guarded by a dataset flag
     so a re-init that returns the same navRoot element doesn't double-bind. */
  function bindNavElements() {
    if (!navRoot || navRoot.dataset.megaNavBound) return;
    navRoot.dataset.megaNavBound = '1';

    navRoot.querySelectorAll('.nav-item.has-mega-panel').forEach((item) => {
      item.addEventListener('mouseenter', function () {
        clearTimers();
        keyboardActivation = false; /* hover is never a keyboard open; clear any stale flag */
        if (HOVER_OPEN_MS === 0) openItem(item);
        else openTimer = setTimeout(() => openItem(item), HOVER_OPEN_MS);
      });

      const panel = item.querySelector('.mega-panel');
      if (panel) {
        panel.addEventListener('mouseenter', function () {
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
        });
        panel.addEventListener('mouseleave', function (e) {
          if (isMovingWithinHeader(e)) return;
          clearTimers();
          closeTimer = setTimeout(closeAll, HOVER_CLOSE_MS);
        });
      }
    });

    navRoot.addEventListener('mouseleave', function (e) {
      if (isMovingWithinHeader(e)) return;
      clearTimers();
      closeTimer = setTimeout(closeAll, HOVER_CLOSE_MS);
    });

    navRoot.addEventListener('mouseenter', function () {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    });

    /* Top-level summary click navigates to its data-href instead of toggling the
       <details>. preventDefault stops the native summary toggle. */
    navRoot.addEventListener('click', function (e) {
      const summary = e.target.closest('summary[data-href]');
      if (!summary) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      /* Keyboard activation (Enter/Space) of a <summary> fires a synthetic click
         with detail === 0. Let it pass so the native <details> toggle runs and the
         `toggle` handler opens the panel, instead of navigating away. */
      if (e.detail === 0) return;
      const url = summary.getAttribute('data-href');
      if (!url) return;
      e.preventDefault();
      window.location.href = url;
    });

    /* Mark genuine keyboard activation so the toggle handler can tell it apart from
       atlantic.js's hover-driven <details> open (which must NOT bypass the timer). */
    navRoot.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
      if (!e.target.closest('.nav-item.has-mega-panel summary')) return;
      keyboardActivation = true;
    });

    /* Sync .is-open with the native <details> toggle. atlantic.js opens the <details>
       on hover, which fires this event; we only honor the open when it came from the
       keyboard (keyboardActivation), so hover stays governed by the mouseenter timer.
       Capture phase is required because the `toggle` event does not bubble. */
    navRoot.addEventListener('toggle', function (e) {
      if (!(e.target instanceof HTMLDetailsElement)) return;
      const item = e.target.closest('.nav-item.has-mega-panel');
      if (!item) return;
      if (e.target.hasAttribute('open')) {
        if (keyboardActivation) openItem(item);
        keyboardActivation = false;
      } else if (item === activeItem) {
        setItemState(item, false);
        activeItem = null;
        if (!navRoot.querySelector('.nav-item.has-mega-panel.is-open')) {
          headerWrap.classList.remove('main-header--panel-open');
        }
      }
    }, true);
  }

  /* Document-level listeners are bound once; they read module-scope state so they
     keep working after the header DOM is re-initialized. */
  function bindDocumentListeners() {
    if (docListenersBound) return;
    docListenersBound = true;

    /* Click outside closes immediately */
    document.addEventListener('click', function (e) {
      if (!activeItem) return;
      if (headerWrap && headerWrap.contains(e.target)) return;
      clearTimers();
      closeAll(true);
    });

    /* Esc closes immediately */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && activeItem) {
        clearTimers();
        closeAll(true);
      }
    });

    /* ---- Mobile: accordion single-open + aria-expanded (delegated on document for resilience) ---- */
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-mobile-accordion-trigger]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        const drawer = trigger.closest('.mobile-dropdown');
        const item = trigger.closest('.mobile-dropdown--item');
        if (!drawer || !item) return;
        const willOpen = item.getAttribute('aria-expanded') !== 'true';
        drawer.querySelectorAll('.mobile-dropdown--item.has-children[aria-expanded="true"]').forEach((sib) => {
          if (sib !== item) {
            sib.setAttribute('aria-expanded', 'false');
            const t = sib.querySelector('[data-mobile-accordion-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
        item.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        return;
      }

    }, true);
  }

  /* (Re-)initialize against the current header DOM. Safe to call again after
     shopify:section:load swaps the header in the theme editor. */
  function initHeaderNav() {
    headerWrap = document.querySelector('.main-header-wrap');
    if (!headerWrap) return;
    clearTimers();
    activeItem = null;
    navRoot = headerWrap.querySelector('.main-header--nav-links');
    bindNavElements();
    bindDocumentListeners();
  }

  document.addEventListener('DOMContentLoaded', initHeaderNav);

  /* Theme editor: the header section's DOM is replaced on reload, so the previous
     nav listeners are gone — re-init when the reloaded section contains the header. */
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && typeof e.target.querySelector === 'function' &&
        (e.target.querySelector('.main-header-wrap') || e.target.classList.contains('shopify-section--header'))) {
      initHeaderNav();
    }
  });
})();


// Desktop product gallery — prev/next arrows over the featured image
(function () {
  function initGalleryArrows(root) {
    var galleries = Array.prototype.slice.call(
      (root || document).querySelectorAll('.premium-pdp [data-product-gallery]')
    );

    galleries.forEach(function (gallery) {
      if (gallery.dataset.galleryArrowsInit === 'true') return;

      var viewport = gallery.querySelector('[data-product-gallery-viewport]');
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-product-gallery-thumbnail]'));
      if (!viewport || thumbs.length < 2) return;
      gallery.dataset.galleryArrowsInit = 'true';

      function currentIndex() {
        for (var i = 0; i < thumbs.length; i++) {
          if (thumbs[i].getAttribute('data-product-gallery-selected') === 'true') return i;
        }
        return 0;
      }

      function go(dir) {
        var next = (currentIndex() + dir + thumbs.length) % thumbs.length;
        thumbs[next].click();
      }

      function makeArrow(modifier, label, dir, path) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'product-gallery--arrow product-gallery--arrow-' + modifier;
        btn.setAttribute('aria-label', label);
        btn.innerHTML = '<svg width="23" height="40" viewBox="0 0 23 40" aria-hidden="true"><path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="' + path + '"/></svg>';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          go(dir);
        });
        return btn;
      }

      viewport.appendChild(makeArrow('prev', 'Previous image', -1, 'M5.14595 20L22.573 2.57298L20 0L0 20L20 40L22.573 37.427L5.14595 20Z'));
      viewport.appendChild(makeArrow('next', 'Next image', 1, 'M17.427 20L0 2.57298L2.57298 0L22.573 20L2.57298 40L0 37.427L17.427 20Z'));
    });
  }

  initGalleryArrows(document);

  document.addEventListener('shopify:section:load', function (event) {
    initGalleryArrows(event.target);
  });
})();

/* ============================================================
   Native search & filter UI (spike/native-search)
   1. Mobile filters drawer open/close with body scroll-lock
   2. AJAX filtering & sorting: intercept filter links, sort selects,
      and price-range inputs, fetch the filtered URL, and swap the
      section in place. atlantic.js's section manager listens for
      shopify:section:unload/load on document at all times, so
      dispatching those events around the swap tears down and rebuilds
      StaticCollection/StaticSearch (quickshop, filters, rimg) cleanly.
   ============================================================ */
(function () {
  'use strict';

  var SECTION_SELECTOR =
    '[data-section-type="static-collection"], [data-section-type="static-search"]';

  /* --- Mobile drawer + body scroll-lock (iOS-safe; same pattern as the
     zoom modal above, whose helpers are closure-scoped) --- */
  var scrollY = 0;
  var lastDrawerTrigger = null;

  function lockBody() {
    scrollY = window.scrollY || window.pageYOffset;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockBody() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
  }

  /* Guard re-entry: opening while already open would re-run lockBody() with the
     body already position:fixed, capturing scrollY as 0 and jumping the page to
     the top on close. */
  function openDrawer() {
    if (document.documentElement.classList.contains('cs-filters-open')) return;
    document.documentElement.classList.add('cs-filters-open');
    if (lastDrawerTrigger) lastDrawerTrigger.setAttribute('aria-expanded', 'true');
    lockBody();
  }

  function closeDrawer() {
    if (!document.documentElement.classList.contains('cs-filters-open')) return;
    document.documentElement.classList.remove('cs-filters-open');
    unlockBody();
    if (lastDrawerTrigger) {
      lastDrawerTrigger.setAttribute('aria-expanded', 'false');
      lastDrawerTrigger.focus();
      lastDrawerTrigger = null;
    }
  }

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-filters-drawer-toggle]');
    if (toggle) {
      lastDrawerTrigger = toggle;
      openDrawer();
      return;
    }
    if (e.target.closest('[data-filters-drawer-close]')) {
      closeDrawer();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* The drawer chrome (close/apply buttons, full-screen sidebar) is
     max-width:940px only. Resizing/rotating to desktop while it's open would
     strand the page: cs-filters-open keeps body position:fixed (scroll-locked)
     with no visible way to dismiss it. Close + unlock when we cross to desktop. */
  if (window.matchMedia) {
    var desktopQuery = window.matchMedia('(min-width: 941px)');
    var onDesktopChange = function (mq) {
      if (mq.matches) closeDrawer();
    };
    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', onDesktopChange);
    } else if (desktopQuery.addListener) {
      desktopQuery.addListener(onDesktopChange);
    }
  }

  /* --- AJAX section swap --- */
  var fetchController = null;

  function getSectionWrapper() {
    var section = document.querySelector(SECTION_SELECTOR);
    return section && section.closest('[id^="shopify-section-"]');
  }

  function dispatchSectionEvent(name, wrapper, sectionId) {
    wrapper.dispatchEvent(
      new CustomEvent(name, { bubbles: true, detail: { sectionId: sectionId } })
    );
  }

  /* Single source of truth for the URL we navigate to. Merges the live price
     inputs into the target (a filter/sort href is generated server-side and
     can't know a price the shopper just typed) and always resets pagination so
     narrowing the result set never lands on a now-empty page. */
  function getUrlWithCurrentState(url) {
    var section = document.querySelector(SECTION_SELECTOR);
    var nextUrl = new URL(url, window.location.origin);
    if (section) {
      var priceInputs = section.querySelectorAll('[data-filter-range]');
      Array.prototype.forEach.call(priceInputs, function (input) {
        if (!input.name) return;
        if (input.value === '') {
          nextUrl.searchParams.delete(input.name);
        } else {
          nextUrl.searchParams.set(input.name, input.value);
        }
      });
    }
    nextUrl.searchParams.delete('page');
    return nextUrl.pathname + nextUrl.search;
  }

  /* Track open groups by their stable filter param, not the positional
     forloop index: a selection can drop a whole filter out of the response
     (all its values hit count 0), shifting every index below it up one. Index
     restore then reopens the wrong group (e.g. Occasion lands in Dress Length's
     old slot). data-filter-param is the same before and after the swap. */
  function openGroupParams(wrapper) {
    var groups = wrapper.querySelectorAll('[data-filter-group][open]');
    return Array.prototype.map.call(groups, function (group) {
      return group.getAttribute('data-filter-param');
    });
  }

  /* Reuse atlantic.js's own summary click handler so its animation state
     stays consistent (it enforces one open group at a time) */
  function reopenGroups(wrapper, params) {
    params.forEach(function (param) {
      var group = wrapper.querySelector(
        '[data-filter-group][data-filter-param="' + param + '"]'
      );
      var summary = group && group.querySelector('[data-filter-group-summary]');
      if (group && summary && !group.hasAttribute('open')) {
        summary.click();
      }
    });
  }

  function ajaxNavigate(url, push) {
    var wrapper = getSectionWrapper();
    if (!wrapper || !window.fetch || !window.DOMParser || !window.AbortController) {
      window.location.href = url;
      return;
    }

    if (fetchController) {
      fetchController.abort();
    }
    var controller = new AbortController();
    fetchController = controller;

    /* Clear the in-flight flag only if this fetch is still the current one.
       A superseding navigation has already replaced fetchController and must
       stay in flight, so an aborted/stale fetch must not null it. The filter
       click handler reads fetchController to lock the sidebar mid-fetch. */
    function settle() {
      if (fetchController === controller) fetchController = null;
    }

    wrapper.classList.add('cs-filtering');

    fetch(url, { signal: controller.signal, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.getElementById(wrapper.id);
        if (!next) throw new Error('section missing in response');

        var sectionId = wrapper.id.replace('shopify-section-', '');
        var openGroups = openGroupParams(wrapper);

        dispatchSectionEvent('shopify:section:unload', wrapper, sectionId);
        wrapper.innerHTML = next.innerHTML;
        dispatchSectionEvent('shopify:section:load', wrapper, sectionId);

        if (push !== false) {
          history.pushState({ csFilters: true }, '', url);
        }

        settle();
        wrapper.classList.remove('cs-filtering');

        requestAnimationFrame(function () {
          reopenGroups(wrapper, openGroups);
        });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        settle();
        wrapper.classList.remove('cs-filtering');
        window.location.href = url;
      });
  }

  /* Filter values, active-filter pills, clear-all — all anchors whose href
     is the committed state. Bubble phase: atlantic.js's own element-level
     handler has already toggled the checkbox visual (optimistic UI) and
     prevented default on [data-disabled] rows. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[data-filter-input], a.active-filter-group__item');
    if (!link || link.hasAttribute('data-disabled')) return;
    if (!link.closest(SECTION_SELECTOR)) return;
    e.preventDefault();
    /* Lock while a fetch is in flight: every filter value link's href is a
       snapshot of the last-rendered state, so a second click before the swap
       lands would navigate from stale params and silently drop the first
       selection. Block it instead — the shopper clicks again once the grid
       settles. Same reason sort/price commits are cheap but these aren't. */
    if (fetchController) return;
    /* Removal links (active-filter pills + clear-all) are authoritative: their
       href already drops the right params. Don't re-merge the live price inputs
       onto them, or clearing/removing a price range just re-adds it and the URL
       never changes. Only sidebar value links need the typed-price merge. */
    var isRemove = link.classList.contains('active-filter-group__item');
    ajaxNavigate(isRemove ? link.href : getUrlWithCurrentState(link.href));
  });

  /* Sort selects: search ([data-search-sort], custom markup) and collection
     ([data-collection-sort], collection-sort.liquid — deliberately not
     #sort-by, which atlantic.js binds to a full reload) */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-search-sort], [data-collection-sort]');
    if (!select) return;
    var nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('sort_by', select.value);
    ajaxNavigate(getUrlWithCurrentState(nextUrl.pathname + nextUrl.search));
  });

  /* Price range inputs. atlantic.js binds a 2s-debounce + full reload
     directly on these inputs; the capture-phase stopPropagation below keeps
     that handler from ever firing. We run our own AJAX instead — but NOT on a
     keystroke timer. A two-field range means a typing debounce always fires
     in the gap between Min and Max, re-rendering the section and stealing the
     field the shopper is about to use. So commit only when focus leaves the
     Min/Max group (or on Enter): Min -> Max tabbing stays one fetch and never
     loses focus. */
  function commitPriceRange() {
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section) return;
    var target = getUrlWithCurrentState(window.location.href);
    var current = new URL(window.location.href);
    current.searchParams.delete('page');
    /* Focusout fires even when the shopper only tabbed through the field — skip
       the section swap (and its flash) when nothing actually changed. */
    if (target === current.pathname + current.search) return;
    ajaxNavigate(target);
  }

  /* Shield only: swallow the events atlantic listens on so its reload never
     fires. No commit here. */
  function shieldPriceInput(e) {
    var input = e.target.closest && e.target.closest('[data-filter-range]');
    if (!input || !input.closest(SECTION_SELECTOR)) return;
    e.stopPropagation();
  }

  document.addEventListener('keyup', shieldPriceInput, true);
  document.addEventListener('change', shieldPriceInput, true);

  /* Commit when focus leaves the Min/Max group. Moving between the two inputs
     keeps focus inside [data-filter-group-range], so it won't commit
     mid-range; tabbing/clicking out (relatedTarget outside the group, or null
     on mobile keyboard dismiss) does. After a section swap the blurred input
     is detached and has no section ancestor, so the guard blocks re-commit. */
  document.addEventListener('focusout', function (e) {
    var input = e.target.closest && e.target.closest('[data-filter-range]');
    if (!input || !input.closest(SECTION_SELECTOR)) return;
    var group = input.closest('[data-filter-group-range]');
    if (e.relatedTarget && group && group.contains(e.relatedTarget)) return;
    commitPriceRange();
  }, true);

  /* Enter inside a price input would natively submit its bare form and drop
     the q/filter params — commit through the AJAX path instead. The two
     number inputs with no submit button mean the browser fires no implicit
     submit event, so catch Enter on keydown directly. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest && e.target.closest('[data-filter-range]');
    if (!input || !input.closest(SECTION_SELECTOR)) return;
    e.preventDefault();
    commitPriceRange();
  });
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.closest || !form.closest(SECTION_SELECTOR)) return;
    if (!form.querySelector('[data-filter-range]')) return;
    e.preventDefault();
    commitPriceRange();
  }, true);

  /* Back/forward restores the section for the URL in the address bar */
  window.addEventListener('popstate', function () {
    if (getSectionWrapper()) {
      ajaxNavigate(window.location.href, false);
    }
  });
})();

/* ============================================================
   GA4 search tracking (spike/native-search)
   Theme owns the GA4 `search` event across every search entry point and tags
   it with `search_location`, so all terms are reported with their source.
   Native Enhanced Measurement still emits `view_search_results` on /search
   page loads (a different event name) as the results-page funnel step.

   gtag loads via the Google & YouTube channel app pixel and is global on
   window; the typeof guard no-ops safely if it ever moves to a sandbox.

   Shopify's Google & YouTube channel pixel ALSO fires a `search` event (term,
   no location) on every /search load — confirmed June 25 2026, and not
   removable without killing Shopify's GA4 integration. So navigated searches
   double-count `search`. Dedupe at report time: GA4 Explore filtered to
   `search_location` is set (regex `.+`). Dropdown-exit clicks never load
   /search, so they're the one path with no Shopify duplicate.
   ============================================================ */
(function () {
  'use strict';

  var GA4_ID = 'G-CY39CX3J4X';

  function fireSearch(term, location) {
    term = (term || '').trim();
    if (!term || typeof gtag !== 'function') return;
    gtag('event', 'search', {
      search_term: term,
      search_location: location,
      send_to: GA4_ID,
      /* Dropdown-exit and footer clicks navigate away immediately; beacon
         transport flushes the hit before the page unloads. */
      transport_type: 'beacon',
    });
  }

  /* GA4 ecommerce select_item for a product clicked out of search. Reads the
     product id/title from data-* attrs on the clicked link (predictive-search
     and product-item snippets). Built-in Item dimensions populate the
     "most-clicked products in search" report; no custom definition needed. */
  function fireSelectItem(link, listId, listName, term) {
    if (!link || typeof gtag !== 'function') return;
    var id = link.getAttribute('data-product-id');
    var title = link.getAttribute('data-product-title');
    if (!id && !title) return;
    gtag('event', 'select_item', {
      item_list_id: listId,
      item_list_name: listName,
      search_term: (term || '').trim(),
      send_to: GA4_ID,
      transport_type: 'beacon',
      items: [{ item_id: id || '', item_name: title || '' }],
    });
  }

  /* Both search forms submit naturally to /search (atlantic.js lets a filled
     query through). The header ls-form carries [data-live-search-form]; the
     results-page form (sections/static-search.liquid) carries
     .results-search-form — no overlap, so one listener tags both by origin. */
  document.addEventListener('submit', function (e) {
    if (!e.target.closest) return;
    var header = e.target.closest('[data-live-search-form]');
    if (header) {
      var hInput = header.querySelector('[data-live-search-form-input]');
      return fireSearch(hInput && hInput.value, 'header_nav');
    }
    var page = e.target.closest('.results-search-form');
    if (page) {
      var pInput = page.querySelector('[name="q"]');
      fireSearch(pInput && pInput.value, 'search_page');
    }
  });

  /* Predictive dropdown clicks. Product/article/page links leave to a PDP and
     never load /search (the gap nothing else records); footer + query
     suggestions go to /search. All are header-originated. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest(
      '.predictive-search__product-suggestion-link,' +
        '.predictive-search__article-suggestion-link,' +
        '.predictive-search__page-suggestion-link,' +
        '.predictive-search__footer-button,' +
        '.predictive-search__query-suggestion-link'
    );
    if (!link) return;
    var input = document.querySelector('[data-live-search-form-input]');
    fireSearch(input && input.value, 'header_predictive');
    /* Product suggestions also record which product was clicked. */
    if (link.classList.contains('predictive-search__product-suggestion-link')) {
      fireSelectItem(link, 'predictive_search', 'Predictive Search', input && input.value);
    }
  }, true); /* capture phase: fire before atlantic.js can stopPropagation */

  /* Search results page product-card clicks. Scoped to .search-product-grid so
     collection grids (same product-item snippet) don't fire. Capture phase +
     beacon for the same survive-nav reason. Identity lives on the card <li>, so
     any of its PDP links (image, overlay, title) counts. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (!e.target.closest('.search-product-grid')) return;
    /* Quick Shop / Add-to-Cart buttons sit inside the overlay anchor; they open
       a modal or add to cart, not a PDP visit, so don't count them. */
    if (e.target.closest('button')) return;
    /* Only product links are PDP visits (skips vendor/collection links). */
    if (!e.target.closest('a[href*="/products/"]')) return;
    var card = e.target.closest('[data-product-item]');
    if (!card) return;
    var input =
      document.querySelector('.results-search-form [name="q"]') ||
      document.querySelector('[data-live-search-form-input]');
    fireSelectItem(card, 'search_results', 'Search Results', input && input.value);
  }, true);
})();

/* ============================================================
   GA4 zero-result / result-count signal (spike/native-search)
   Fires once on a search-results page load with the server-rendered count, so
   "searches that returned nothing" are reportable. Distinct event name from
   `search` (which fires on the action) to avoid doubling. Not fired on the
   AJAX filter/sort swaps — a filter narrowing to 0 is not a search that
   returned 0. Report: GA4 on `search_results` where number_of_results = 0.
   Note: search.results_count is raw; if all matches are out of stock the grid
   hides them (static-search.liquid filters OOS) while count stays > 0 — rare.
   ============================================================ */
(function () {
  'use strict';

  var GA4_ID = 'G-CY39CX3J4X';

  function init() {
    var el = document.querySelector(
      '[data-section-type="static-search"][data-search-results]'
    );
    if (!el) return;
    var term = (el.getAttribute('data-search-query') || '').trim();
    if (!term) return;
    var count = parseInt(el.getAttribute('data-search-results'), 10);
    if (isNaN(count)) return;

    /* The Google & YouTube channel pixel may still be loading on first paint;
       poll briefly so the page-load hit isn't dropped before gtag exists. */
    var tries = 0;
    (function fire() {
      if (typeof gtag === 'function') {
        gtag('event', 'search_results', {
          search_term: term,
          number_of_results: count,
          search_location: 'search_page',
          send_to: GA4_ID,
        });
        return;
      }
      if (tries++ < 12) setTimeout(fire, 300);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ============================================================
   GA4 Top 5 / trend report click tracking
   One delegated listener for every [data-top5-track] element:
     home_see_the_edit    — header button on the what-to-wear section
     home_lifestyle_image — gallery slide links on the what-to-wear section
     home_product_card    — product tiles on the what-to-wear section
     tr_product_card      — product cards in the Top 5 trend report article
     tr_quickshop         — quick-shop buttons in the Top 5 trend report article
   Decides whether the monthly trend report earns its upkeep. Report: GA4 on
   `top5_click` split by top5_target / look_number. No overlap with the search
   select_item listener (that one is scoped to .search-product-grid), and the
   quickshop button is a sibling of the product anchor, so one click never
   carries two [data-top5-track] ancestors.
   ============================================================ */
(function () {
  'use strict';

  var GA4_ID = 'G-CY39CX3J4X';

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var el = e.target.closest('[data-top5-track]');
    if (!el || typeof gtag !== 'function') return;
    gtag('event', 'top5_click', {
      top5_target: el.getAttribute('data-top5-track'),
      look_number: el.getAttribute('data-look') || '',
      item_handle: el.getAttribute('data-product-handle') || '',
      send_to: GA4_ID,
      /* Most tracked clicks navigate immediately; beacon transport flushes
         the hit before the page unloads. */
      transport_type: 'beacon',
    });
  }, true); /* capture phase: fire before any handler can stopPropagation */
})();
